export default __webpack_public_path__ + "6d3d25f4820d0da8f01fa3d2c7cbb8c2.woff2";